<style lang="scss" scoped>.kilometers {
        display: block;
        height: 30px;
        padding: 0;
        line-height: 30px;
    }</style>

<template>
    <div class="popup px-16 pt-24 p-md-24 p-lg-56" ref="fixBottom">
        <div class="close" @click="$emit('close')"></div>
        <h2 class="mb-16 mb-md-32">Locatie</h2>
        <p class="mb-32">Kies een optie om verder te gaan.</p>

        <div class="d-flex align-items-center format-row mb-32">
            <a
                class="mr-24"
                @click.prevent="setFormat('WORDPRESS')"
                :class="{
                    active: format === 'WORDPRESS',
                    'pl-0': format !== 'WORDPRESS'
                }"
                >Inspirerende locaties</a
            >
            <a
                @click.prevent="setFormat('GOOGLE_MAPS')"
                :class="{ active: format === 'GOOGLE_MAPS' }"
                >Eigen locatie</a
            >
        </div>

        <div class="mb-32">
            <ValidationObserver
                v-slot="{ invalid, errors }"
                tag="div"
                :slim="true"
                ref="observer"
            >
                <template v-if="format === 'WORDPRESS'">
                    <el-input
                        v-model="location"
                        :options="locations"
                        class="mb-24"
                        type="select"
                        :name="translations.practical_details.location"
                        rules="required"
                        :placeholder="
                            translations.practical_details.location_choose
                        "
                    />
                </template>

                <template v-if="format === 'GOOGLE_MAPS'">
                    <div class="d-flex mb-8">
                        <ValidationProvider
                            ref="location"
                            vid="location"
                            class="w-100"
                            :name="translations.practical_details.location"
                            rules="required"
                            tag="div"
                            v-slot="{ classes }"
                        >
                            <vue-google-autocomplete
                                ref="locationAutocomplete"
                                id="location"
                                name="location"
                                :types="''"
                                :class="classes"
                                :placeholder="
                                    translations.practical_details
                                        .location_choose
                                "
                                :country="['be']"
                                v-on:placechanged="getAddressData"
                                v-on:blur="validateAddress"
                                v-on:change="validateAddress"
                            ></vue-google-autocomplete>
                        </ValidationProvider>
                        <ValidationProvider
                            ref="range"
                            vid="range"
                            :name="
                                translations.practical_details.location_range
                            "
                            rules="integer|min:1|max:300"
                            v-slot="{ classes }"
                            tag="div"
                        >
                            <input
                                type="number"
                                id="range"
                                class="ml-16"
                                :class="classes"
                                :name="
                                    translations.practical_details
                                        .location_range
                                "
                                min="1"
                                max="300"
                                v-model="radius"
                                :placeholder="
                                    translations.practical_details
                                        .location_range
                                "
                            />
                        </ValidationProvider>
                        <span class="kilometers ml-24 font-weight-light"
                            >km</span
                        >
                    </div>
                    <span
                        v-if="
                            (errors.location != null &&
                                errors.location.length > 0) ||
                                (errors.range != null &&
                                    errors.range.length > 0)
                        "
                        class="error small d-block mb-24"
                        >{{ errors.location[0] || errors.range[0] }}</span
                    >
                </template>
            </ValidationObserver>
        </div>

        <div class="popup-footer d-flex align-items-center">
            <button
                class="btn btn-accent btn-sm-100 text-white"
                @click="submit"
                v-html="translations.participant_amount_popup.select"
            ></button>
        </div>
    </div>
</template>

<script>
import core from "../day-configurator-core";
import safariFixedBottom from "../../mixins/safari-fixed-bottom";
import { bus } from "@/app";
import { ValidationProvider, ValidationObserver } from "vee-validate";
var cloneDeep = require("lodash.clonedeep");

export default {
    mixins: [core, safariFixedBottom],

    components: { ValidationProvider, ValidationObserver },

    props: {
        localSchedule: {
            type: Object,
            required: true
        },
        locations: {
            type: Array,
            required: true
        }
    },

    data: () => ({
        format: "WORDPRESS",
        location: null,
        radius: null
    }),

    created() {
        this.readSchedule();
    },

    methods: {
        readSchedule() {
            if (this.localSchedule.location_type === "WORDPRESS") {
                this.format = "GOOGLE_MAPS";
            } else if (this.localSchedule.location_type === "GOOGLE_MAPS") {
                this.format = "WORDPRESS";
            }
        },

        submit() {
            bus.$emit("locationUpdate", {
                location: this.location,
                location_type: this.format,
                radius: this.radius
            });
            this.$emit("close");
        },

        setFormat(format) {
            this.format = format;
            this.location = null;
            this.radius = null;
        },

        getAddressData: function(addressData, placeResultData, id) {
            bus.$emit("addressUpdate", placeResultData.name);
            this.location = placeResultData.place_id;
            this.validateAddress();
        },

        validateAddress: function(payload) {
            if (payload != null && payload == "") this.location = null;
            this.$refs.location.validate(this.location);
        }
    }
};
</script>
